module.exports = __webpack_public_path__ + "static/media/1-item-a.8804ba2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/1-item-a.png
// module id = 1154
// module chunks = 33